import { useEffect, useState } from 'react';
import { Edit, Location, Modal, Search, Typography } from '@lamimed/pantheon';
import { useRouter } from 'next/router';

import { Location as LocationModel } from 'models/Location';

import { useCitySelection } from 'hooks/useCitySelection';
import { useSWRGet } from 'hooks/useSWRGet';

import { sendToErrorTracking } from 'utils/sendToErrorTracking';

import * as S from './styles';

interface ModalCitySelectionProps {
  editable?: boolean;
}

export const ModalCitySelection: React.FC<ModalCitySelectionProps> = ({
  editable = false,
}) => {
  const router = useRouter();
  const categorySlug = router.query.category;

  const [filter, setFilter] = useState('');
  const [open, setOpen] = useState(false);
  const { data, error } = useSWRGet<LocationModel[]>(
    `/locations/?name=${filter}&category=${categorySlug}&has_products=true`,
  );

  if (error) {
    sendToErrorTracking({ error, where: 'ModalCitySelection', context: data });

    router.push('/500');
  }

  const { selectedCity, fillSelectedCity, removeSelectedCity } =
    useCitySelection();

  const openCitySelectionModal = () => {
    removeSelectedCity();

    setOpen(true);
  };

  const handleCitySelection = (city: string) => {
    fillSelectedCity(city);

    setOpen(false);
  };

  useEffect(() => {
    setOpen(!selectedCity);
  }, [selectedCity]);

  return (
    <>
      {editable && (
        <S.ModalEditableArea onClick={openCitySelectionModal}>
          <Location color="secondary" />

          <Typography variant="body_text_2" color="text__highlight">
            {selectedCity
              ? `Stai vedendo servizi a ${selectedCity}`
              : 'Seleziona la tua città per servirti al meglio'}
          </Typography>

          <Edit color="secondary" />
        </S.ModalEditableArea>
      )}

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="small"
        animationOptions={{ enter: true, leave: false }}
      >
        <S.ModalContent>
          <Typography>Dove vuoi che ti raggiungiamo?</Typography>

          <S.SearchGroup>
            <S.SearchField
              onChange={(e) => setFilter(e.target.value)}
              placeholder="Trova la tua città"
            />

            <S.SearchIcon />
          </S.SearchGroup>

          <S.SearchBox>
            {data?.length ? (
              data?.map((city) => (
                <S.SearchBoxItem
                  key={city.id}
                  onClick={() => handleCitySelection(city.name)}
                >
                  {city.name}
                </S.SearchBoxItem>
              ))
            ) : (
              <S.Empty>
                <Search width={24} height={24} color="neutral" />

                <Typography>Nessuna città trovata.</Typography>
              </S.Empty>
            )}
          </S.SearchBox>
        </S.ModalContent>
      </Modal>
    </>
  );
};
